import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import v3Image from "../../assets/DoorAccess/g3-reader-pro.jpg";
import productImage from "../../assets/product-list-assets/cameras/door-access/g3-reader-pro.jpg";
import type { Product } from "../../types";
import { readersAndIntercom } from "../product-list-groups/readersAndIntercom";
import {
  cameraReader,
  directory,
  hand,
  mobileAppAccess,
  nfcCard,
  outdoorReady,
  pinAccess,
  readerPowerMethod,
  touchPassSupport,
  twoWayIntercom,
} from "../properties";

export const g3ReaderPro: Product = {
  id: "g3ReaderPro",
  productTitle: "G3 Reader Pro",
  descriptionMaxWidth: 204,
  image: { src: productImage, width: 200, height: 160 },
  v3Image: {
    src: v3Image,
    width: 255,
    height: 182,
  },
  productListGroup: readersAndIntercom,
  description: "g3ReaderPro.description",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.DoorAccess}/ua-g3-pro`,
  ],
  storePathParts: {
    category: UniFiChildCategorySlug.DoorAccessReaders,
    productSlug: "ua-g3-pro",
  },
  isNew: true,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '160 x 40.4 x 40.55 mm\n(6.3 x 1.59 x 1.6")',
      },
    },
    {
      propertyId: cameraReader.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: twoWayIntercom.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: directory.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: touchPassSupport.id,
      value: {
        type: "string",
        value: "Apple Wallet\nGoogle Wallet",
      },
    },
    {
      propertyId: pinAccess.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: nfcCard.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: mobileAppAccess.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: hand.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: outdoorReady.id,
      value: {
        type: "translation",
        value: "g3ReaderPro.outdoorReady",
      },
    },
    {
      propertyId: readerPowerMethod.id,
      value: {
        type: "translation",
        value: "readerPowerMethod.poeViaUniFiControlHub",
      },
    },
  ],
  notes: ["g3ReaderPro.note.1"],
};
